import BaseComponent from "../../../baseComponent.js";
import styles from "./styles.scss";

export default class ChartType extends BaseComponent {
  handleTypeChange(event) {
    this.props.onLegendChange("chartType", event.target.value);
  }

  render() {
    return (
      <div className={styles.configLineWrapper}>
        <div className={styles.configLine}>
          <div className={styles.configLabel}>Chart Type</div>
          <div className={styles.configValue}>
            <select className="browser-default"
                    value={this.props.chartType} onChange={this.handleTypeChange}>
              <option value="line">Line</option>
              <option value="bar">Stacked Bar</option>
              <option value="bar2">Bar</option>
              <option value="range">Range Area</option>
              <option value="bubble">Bubble</option>
            </select>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/chartType.jsx